import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fields"]

  connect() {
    console.log("ClearFieldsController connected")
  }
  clear(e) {
    e.preventDefault()
    this.fieldsTargets.forEach((field) => {
      field.value = ""
    })
  }
}
